import { takeEvery } from 'redux-saga/effects';
import authorizedCheck from './authorizedCheck';
import authorizedLogin from './authorizedLogin';
import authorizedLogout from './authorizedLogout';
import authorizedRegistration from './authorizedRegistration';
import {
  AUTHORIZED_CHECK, AUTHORIZED_LOGIN, AUTHORIZED_LOGOUT, AUTHORIZED_REGISTRATION, FORGOT_PASSWORD,
} from '../actions';
import { AUTHORIZED_MODULE } from '../../../configs/moduleNames';
import forgotPassword from './forgotPassword';

export default function* watchClient() {
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_REGISTRATION, authorizedRegistration);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_LOGIN, authorizedLogin);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_LOGOUT, authorizedLogout);
  yield takeEvery(AUTHORIZED_MODULE + AUTHORIZED_CHECK, authorizedCheck);
  yield takeEvery(AUTHORIZED_MODULE + FORGOT_PASSWORD, forgotPassword);
}
